<template>
  <NavHeader v-if="!$route.meta.hideH5Header" />

  <RouterView />
  <Loading />

  <H5LoginIn />

  <H5CategoryDialog />

  <H5DropshippingDialog />
</template>

<script setup>
import H5CategoryDialog from '@/components/H5/H5CategoryDialog/index.vue'
import Loading from '@/components/Loading/index.vue'
import { NavHeader } from '@/components/H5/NavHeader'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import H5LoginIn from '@/components/H5/H5LoginIn/index.vue'
import { H5DropshippingDialog } from '@/components/Dropshipping'

onMounted(() => {
  waitForElement().then(element => {
    element.addEventListener('click', function () {
      gaAnalytics('mp_consultation_click', 'mp_consultation_click')
      buriedPointUtil({ eventId: 'MPWH202' })
    })
  })
})

const waitForElement = () => {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const element = document.querySelector('.intercom-launcher')
          if (element) {
            observer.disconnect() // 找到元素后停止观察
            resolve(element) // 返回找到的元素
          }
        }
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}
</script>

<style lang="less">
@import './index.less';
</style>

<style lang="less" scoped>
/* PC端样式 */
@media (max-width: 1440px) {
  :global(.intercom-launcher) {
    right: 48px !important;
  }
}

@media (min-width: 1441px) {
  :global(.intercom-launcher) {
    right: 144px !important;
  }
}

@media (max-width: 430px) {
  :global(.intercom-launcher) {
    right: 12px !important;
  }
}

.custom-category-dialog {
  ::v-deep(.popup-content) {
    border-radius: 0;
    background-color: transparent;
  }
}
</style>
